import React, { useMemo } from "react";
import EChart from "./EChart";
import { ECHART_TOOLTIP, ECHART_TOOLBOX } from "../../Utilities/echartsTheme";
import { formatNumber } from "../../Utilities/numbers";

const EChartsHeatmap = ({ categories, statuses, matrix, valueKey = "total_value" }) => {
  const option = useMemo(() => {
    const yLabels = categories || [];
    const xLabels = statuses || [];

    const rawValues = [];
    let maxVal = 0;

    yLabels.forEach((cat, yi) => {
      xLabels.forEach((st, xi) => {
        const cell = (matrix || []).find((r) => r.category === cat && r.status === st);
        const val = cell ? Number(cell[valueKey]) || 0 : 0;
        if (val > maxVal) maxVal = val;
        rawValues.push({ xi, yi, val });
      });
    });

    const heatData = rawValues.map(({ xi, yi, val }) => {
      const ratio = maxVal > 0 ? val / maxVal : 0;
      return {
        value: [xi, yi, val],
        label: {
          show: val > 0,
          color: ratio > 0.4 ? "#fff" : "#1E3A5F",
          fontWeight: ratio > 0.4 ? "bold" : "normal",
        },
      };
    });

    return {
      tooltip: {
        ...ECHART_TOOLTIP,
        position: "top",
        formatter: (p) => {
          return `<div style="font-weight:600;margin-bottom:4px">${yLabels[p.value[1]]}</div>${xLabels[p.value[0]]}: ${formatNumber(p.value[2])}`;
        },
      },
      toolbox: ECHART_TOOLBOX,
      grid: { left: "3%", right: "4%", bottom: "8%", top: "5%", containLabel: true },
      xAxis: {
        type: "category",
        data: xLabels,
        splitArea: { show: true },
        axisLabel: { fontSize: 10, rotate: 30, hideOverlap: true },
      },
      yAxis: {
        type: "category",
        data: yLabels,
        splitArea: { show: true },
        axisLabel: { fontSize: 10, width: 100, overflow: "truncate" },
      },
      visualMap: {
        min: 0,
        max: maxVal || 1,
        calculable: true,
        orient: "horizontal",
        left: "center",
        bottom: 0,
        itemWidth: 12,
        itemHeight: 80,
        textStyle: { fontSize: 10 },
        inRange: { color: ["#DBEAFE", "#60A5FA", "#2563EB", "#1E3A8A"] },
      },
      series: [
        {
          type: "heatmap",
          data: heatData,
          itemStyle: {
            borderColor: "#fff",
            borderWidth: 1,
          },
          label: {
            show: true,
            formatter: (p) => (p.value[2] > 0 ? formatNumber(p.value[2]) : ""),
            fontSize: 11,
          },
          emphasis: {
            itemStyle: { shadowBlur: 10, shadowColor: "rgba(0,0,0,0.3)" },
          },
          progressive: 1000,
          animation: true,
        },
      ],
    };
  }, [categories, statuses, matrix, valueKey]);

  if (!categories || categories.length === 0) {
    return (
      <div className="d-flex align-items-center justify-content-center h-100 text-muted">
        No category data available
      </div>
    );
  }

  return <EChart option={option} />;
};

export default EChartsHeatmap;
